const initialState = {
    filter: "All",
};

export default initialState;